import React from 'react'
import {
    StyledCardItem,
    StyledCardItemLeft,
    StyledCardItemRight,
    StyledCardItemName,
    StyledCardItemValue
} from './styled'

const CardItem = ({ left, right, active, ...props }) => {
    return (
        <StyledCardItem {...props}>
            <StyledCardItemLeft>
                <StyledCardItemName>{left.name}</StyledCardItemName>
                <StyledCardItemValue active={active}>{left.value}</StyledCardItemValue>
            </StyledCardItemLeft>
            {
                right &&
                <StyledCardItemRight>
                    {right}
                </StyledCardItemRight>
            }
        </StyledCardItem>
    )
}

export default CardItem
